import { defineStore } from 'pinia';
export const useHelpdeskStore = defineStore('helpdesk', {
  state: () => ({
    client: null,
    adminClient: null,
    authLoading: false,
  }),
  getters: {},
  actions: {
    async initClient() {
      throw new Error('Method initClient not implemented.');
    },
    closeClient() {
      throw new Error('Method closeClient not implemented.');
    },
    login() {
      throw new Error('Method login not implemented.');
    },
    injectAnswer(answer: any) {
      throw new Error('Method injectAnswer not implemented.');
    },
    dispatchAction(action: any) {
      throw new Error('Method dispatchAction not implemented.');
    },
  },
});
